export default __webpack_public_path__ + "static/media/success.8ae0e949.svg";